// extracted by mini-css-extract-plugin
export default {"input":"NumberSlideInput_input__wJ1vh","mark":"NumberSlideInput_mark__ykdRf","value":"NumberSlideInput_value__xfLDF"};